import React, { useState, useEffect, useCallback } from 'react';
import { useNavigate } from 'react-router-dom';
import { Plus, Edit2, Trash2, Power } from 'lucide-react';
import AdminLayout from '../../components/admin/AdminLayout';
import AdminTable from '../../components/admin/AdminTable';
import { programsAdminAPI } from '../../services/api';
import '../../styles/admin-shared.css';

const ProgramsListPage = () => {
  const navigate = useNavigate();
  const [programs, setPrograms] = useState([]);
  const [loading, setLoading] = useState(true);

  const fetchPrograms = useCallback(async () => {
    setLoading(true);
    try {
      const res = await programsAdminAPI.list();
      setPrograms(res.data?.data || []);
    } catch (err) {
      console.error('Erro ao carregar programas:', err);
      setPrograms([]);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchPrograms();
  }, [fetchPrograms]);

  const handleToggle = async (program) => {
    try {
      await programsAdminAPI.toggleStatus(program.id, !program.is_active);
      fetchPrograms();
    } catch (err) {
      console.error('Erro ao alternar status:', err);
      alert('Erro ao alternar status do programa');
    }
  };

  const handleDelete = async (program) => {
    if (!window.confirm(`Excluir o programa "${program.label}"? Essa ação é permanente.`)) {
      return;
    }
    try {
      await programsAdminAPI.delete(program.id);
      fetchPrograms();
    } catch (err) {
      const message = err.response?.data?.message || 'Erro ao excluir programa';
      alert(message);
    }
  };

  const columns = [
    {
      key: 'label',
      label: 'Programa',
      render: (value, row) => (
        <div className="user-cell">
          <div
            className="user-avatar"
            style={{ background: row.primary_color || '#1A95FF' }}
          >
            {value?.charAt(0)}
          </div>
          <div>
            <div className="user-name">{value}</div>
            <div className="user-email">{row.slug}</div>
          </div>
        </div>
      ),
    },
    {
      key: 'domain',
      label: 'Domínio',
      render: (value) => value || <span style={{ opacity: 0.6 }}>—</span>,
    },
    {
      key: 'active_enrollments',
      label: 'Inscrições ativas',
      render: (value) => <span>{value ?? 0}</span>,
    },
    {
      key: 'blocker_strategy',
      label: 'Bloqueador',
    },
    {
      key: 'is_active',
      label: 'Status',
      render: (value) =>
        value ? (
          <span className="status-badge active">Ativo</span>
        ) : (
          <span className="status-badge inactive">Inativo</span>
        ),
    },
  ];

  return (
    <AdminLayout>
      <div className="users-page">
        <div className="page-header">
          <div>
            <h1>Programas</h1>
            <p>Gerencie programas (Freedom, Balance, ...) e seus dados de marca.</p>
          </div>
          <button
            className="btn btn-primary btn-with-icon"
            onClick={() => navigate('/admin/programs/new')}
          >
            <Plus size={18} /> Novo Programa
          </button>
        </div>

        <AdminTable
          columns={columns}
          data={programs}
          loading={loading}
          actions={(row) => (
            <>
              <button
                className="btn-icon"
                title="Editar"
                onClick={() => navigate(`/admin/programs/${row.id}/edit`)}
              >
                <Edit2 size={16} />
              </button>
              <button
                className="btn-icon"
                title={row.is_active ? 'Desativar' : 'Ativar'}
                onClick={() => handleToggle(row)}
              >
                <Power size={16} />
              </button>
              <button
                className="btn-icon danger"
                title="Excluir"
                onClick={() => handleDelete(row)}
                disabled={row.active_enrollments > 0}
              >
                <Trash2 size={16} />
              </button>
            </>
          )}
        />
      </div>
    </AdminLayout>
  );
};

export default ProgramsListPage;
